import { render, staticRenderFns } from "./UserOptions.vue?vue&type=template&id=21dab0bd&"
import script from "./UserOptions.vue?vue&type=script&lang=js&"
export * from "./UserOptions.vue?vue&type=script&lang=js&"
import style0 from "./UserOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21dab0bd')) {
      api.createRecord('21dab0bd', component.options)
    } else {
      api.reload('21dab0bd', component.options)
    }
    module.hot.accept("./UserOptions.vue?vue&type=template&id=21dab0bd&", function () {
      api.rerender('21dab0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Core/Header/UserOptions.vue"
export default component.exports